import { processInclude } from './util/common';

function panelToggle (element) {
    let actionBarclosestContainer = element.closest('.action-bar-container');
    let closestContainer = element.closest('.action-bar');
    let target = closestContainer.find(element.data('target'));

    // reset other open panels
    actionBarclosestContainer.find('.js-panel').addClass('hidden');
    actionBarclosestContainer.find('.arrow-action-close').addClass('hidden');
    actionBarclosestContainer.find('.arrow-action-open').removeClass('hidden');

    if (element.hasClass('open')) {
        closePanelFromElement(element, closestContainer, target);
    } else {
        openPanelFromElement(element, closestContainer, target);
    }
}

function openPanelFromElement (element, closestContainer, target) {
    $('.js-panel.js-sizePanel').addClass('hidden');
    $('.js-panel-opener').removeClass('open');
    $('.js-panel.js-colorPanel').addClass('hidden');
    $('.js-panel-opener').find('.arrow-action-close').addClass('hidden');
    $('.js-panel-opener').find('.arrow-action-open').removeClass('hidden');
    element.addClass('open');

    // Open current panel
    target.removeClass('hidden');
    closestContainer.find('.arrow-action-close').removeClass('hidden');
    closestContainer.find('.arrow-action-open').addClass('hidden');
}

function closePanelFromElement (element, closestContainer, target) {
    element.removeClass('open');
    
    // Open current panel
    target.addClass('hidden');
    closestContainer.find('.arrow-action-close').addClass('hidden');
    closestContainer.find('.arrow-action-open').removeClass('hidden');
}

$(document).ready(function () {
    $('body').on('click', '.js-panel-opener', function (e) {
        e.preventDefault();
        panelToggle($(e.currentTarget));
    });

    processInclude(require('./wishlist/wishlist'));
});
